<template>
  <el-dialog
    title="添加标签"
    :visible.sync="dialogVisible"
    width="70%"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @closed="$emit('close')"
  >
    <div>
      <el-table
        v-loading="loading"
        :data="dataObj.baseTag ? Object.keys(dataObj.baseTag).map(id => dataObj.baseTag[id]) : []"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="title"
          label="名称"
          width="180"
        />
        <!-- <el-table-column
          prop="tagType"
          label="tagType"
        /> -->
        <el-table-column
          prop="isChange"
          label="是否可添加"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.isChange ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
        >
          <template v-if="scope.row.isChange" slot-scope="scope">
            <el-button type="primary" size="mini" @click="myAdd(scope.row)">添加标签</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      v-if="dialogVisible1"
      :title="`添加: ${activeItem.title}`"
      :visible.sync="dialogVisible1"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div v-if="activeItem.isRange === 1" class="content">
        <div class="content1 search_box">
          <el-input v-model="dataIfon.tag_name" placeholder="请输入标签名" style="width:150px;margin-right:35px" />

          <div v-if="activeItem.title == '关注时间' || activeItem.title == '互动时间'" class="content_main">
            <el-input v-model="dataIfon.min" placeholder="请输入最小值 （不包含）" style="margin-right:15px" :type="'number'" @blur="cznumone" />
            <el-input v-model="dataIfon.max" placeholder="请输入最大值（包含）" :type="'number'" @blur="maxnum" />
          </div>
          <div v-else class="content_main">
            <el-input v-model="dataIfon.min" placeholder="请输入最小值 （不包含）" style="margin-right:15px" :type="'number'" @blur="cznum" />
            <el-input v-model="dataIfon.max" placeholder="请输入最大值（包含）" :type="'number'" @blur="maxnum" />
          </div>
        </div>
        <div v-if="activeItem.unit" style="margin-top:5px; color:#7a7a7a;"><span>单位：</span><span>{{ activeItem.unit }}</span></div>
        <!-- <div style="margin-top:5px; color:#7a7a7a;">
          <span>提示：</span>
          <span v-if="activeItem.title == '关注时间' || activeItem.title == '互动时间'">xx以下最小值为 0，xx以上最大值为 0</span>
          <span v-else>xx以下最小值为 1，xx以上最大值为 0</span>
        </div> -->
      </div>
      <div style="margin:20px 0px 5px 0px">已有标签</div>
      <el-table
        :data="tableData"
        border
        style="width: 100%; "
      >
        <el-table-column
          prop="tagName"
          label="标签名"
          width="180"
        />
        <el-table-column
          prop="tagData"
          label="标签值"
        />
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addLabel">添加</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getLabelList, addLabel } from '@/api/labelGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      dialogVisible: true,
      dialogVisible1: false,
      item: {},
      dataObj: {},
      loading: false,
      activeItem: null,
      pageIfon: {
        page: 1,
        pageSize: 10
      },
      pageIfon1: {
        page: 1,
        page_size: 10,
        tag_type: undefined
      },
      dataIfon: {
        tag_name: undefined,
        min: undefined,
        max: undefined,
        tag_type: undefined
      },
      tableData: [],
      total: null
    }
  },
  created() {
    this.getLabelList()
  },
  methods: {
    async getLabelList() {
      this.loading = true
      const data = await getLabelList(this.pageIfon)
      this.dataObj = this.convertToHump(data.data)
      this.loading = false
    },
    async addLabel() {
      if (this.verification(this.dataIfon)) {
        await addLabel(this.dataIfon)
        this.$message({
          message: '添加标签成功',
          type: 'success'
        })
        this.closeDialog()
      }
    },

    // 重置
    closeDialog() {
      this.dataIfon = {
        tag_name: undefined,
        min: undefined,
        max: undefined,
        tag_type: undefined
      }
      this.activeItem = null
      this.tableData = []
      this.pageIfon1 = {
        page: 1,
        page_size: 10,
        tag_type: undefined
      }
      this.total = null
      this.dialogVisible1 = false
    },

    verification(data) {
      console.log(data)
      if (!data.tag_name || !data.min || !data.max) {
        this.$message({
          message: !data.tag_name ? '请输入标签名' : !data.min ? '请输入最小值' : !data.max ? '请输入最大值' : '',
          type: 'warning'
        })
        return false
      }
      return true
    },

    async myAdd(item) {
      this.activeItem = item
      this.dataIfon.tag_type = item.tagType
      this.pageIfon1.tag_type = item.tagType
      this.dialogVisible1 = true
      const data = await getLabelList(this.pageIfon1)
      this.tableData = this.convertToHump(data.data.list)
      this.total = data.data.total
    },

    async fetchPageSize(page_size) {
      this.pageIfon1.page_size = page_size
      const data = await getLabelList(this.pageIfon1)
      this.tableData = this.convertToHump(data.data.list)
      this.total = data.data.total
    },

    async fetchCurrentPage(page) {
      this.pageIfon1.page = page
      const data = await getLabelList(this.pageIfon1)
      this.tableData = this.convertToHump(data.data.list)
      this.total = data.data.total
    },
    cznum() {
      // eslint-disable-next-line eqeqeq
      if (this.dataIfon.min <= 1) {
        /* this.dataIfon.min = 1 */
      }
    },
    cznumone() {
      // eslint-disable-next-line eqeqeq
      if (this.dataIfon.min <= 0) {
        this.dataIfon.min = 0
      }
    },
    maxnum() {
      // eslint-disable-next-line eqeqeq
      if (this.dataIfon.max <= 0) {
        this.dataIfon.max = 0
      }
    }
  }
}
</script>

<style scoped lang="less">
.content{
  .content1{
     display: flex;
   .content_main{
     display: flex;
   }
  }

}
/* @import url(); 引入css类 */
.content_main /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.content_main /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
